import React, { useMemo } from "react";

import { FileDown } from "lucide-react";

import ToolbarIconButton from "../ToolbarIconButton";
import { useDocument } from "../../../documents/editor/EditorContext";

export default function DownloadJson() {
  const doc = useDocument();
  const href = useMemo(() => {
    return `data:text/plain,${encodeURIComponent(JSON.stringify(doc, null, "  "))}`;
  }, [doc]);

  return (
    <ToolbarIconButton
      tooltip="Download JSON file"
      icon={<FileDown className="size-4" />}
      href={href}
      download="emailTemplate.json"
    />
  );
}
